var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 0.600006C8.84741 0.600006 0.599976 8.84744 0.599976 19C0.599976 29.1526 8.84741 37.4 19 37.4C29.1525 37.4 37.4 29.1526 37.4 19C37.4 8.84744 29.1525 0.600006 19 0.600006ZM19 2.20001C28.2878 2.20001 35.8 9.71215 35.8 19C35.8 28.2879 28.2878 35.8 19 35.8C9.71212 35.8 2.19998 28.2879 2.19998 19C2.19998 9.71215 9.71212 2.20001 19 2.20001ZM19 7.80001C18.3635 7.80001 17.753 8.05286 17.3029 8.50295C16.8528 8.95304 16.6 9.56349 16.6 10.2C16.6 10.8365 16.8528 11.447 17.3029 11.8971C17.753 12.3471 18.3635 12.6 19 12.6C19.6365 12.6 20.2469 12.3471 20.697 11.8971C21.1471 11.447 21.4 10.8365 21.4 10.2C21.4 9.56349 21.1471 8.95304 20.697 8.50295C20.2469 8.05286 19.6365 7.80001 19 7.80001ZM15.8 15.8V17.4H16.6H17.4V27.8H16.6H15.8V29.4H16.6H17.4H20.6H21.4H22.2V27.8H21.4H20.6V15.8H19.8H16.6H15.8Z",
    fill: "#62AA51"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIIcon);
export default __webpack_public_path__ + "static/media/IIcon.8c9882ea35ad80b124870d1d045225bf.svg";
export { ForwardRef as ReactComponent };